import React from 'react';

const ProtectedRoute = ({ 
  children, 
  requiredRoles = ['user', 'admin', 'agent', 'jk_manager'],
  redirectPath = '/login'
}) => {
  // Check authentication and roles
  const checkAuth = () => {
    const token = localStorage.getItem('token');
    const userInfoStr = localStorage.getItem('user');
    
    // If no token is found, redirect to login
    if (!token) {
      return { 
        isAuthenticated: false, 
        redirectReason: 'Kein Token gefunden' 
      };
    }

    // If no user information is found, redirect to login
    if (!userInfoStr) {
      return { 
        isAuthenticated: false, 
        redirectReason: 'Keine Benutzerinformationen gefunden' 
      };
    }

    try {
      const userInfo = JSON.parse(userInfoStr);
      
      // Check if the role is allowed
      const isRoleAllowed = requiredRoles.includes(userInfo.role);
      
      return {
        isAuthenticated: isRoleAllowed,
        redirectReason: !isRoleAllowed ? 'Nicht autorisierte Rolle' : null,
        userRole: userInfo.role
      };
    } catch (error) {
      // Error parsing user information
      return { 
        isAuthenticated: false, 
        redirectReason: 'Fehler beim Parsen der Benutzerinformationen' 
      };
    }
  };

  const authCheck = checkAuth();

  // If not authenticated, show a message or redirect
  if (!authCheck.isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Zugriff verweigert</h2>
          <p className="text-gray-700">{authCheck.redirectReason}</p>
          <a 
            href="/login" 
            className="mt-4 inline-block px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
          >
            Zurück zum Login
          </a>
        </div>
      </div>
    );
  }

  // Show content if authenticated and authorized
  return children;
};

export default ProtectedRoute;
